// Google Identity Services：スクリプトの読み込みとボタンの表示（ログイン画面と設定の「Googleと連携」で共用）。
import { api } from '../api';

declare global {
  interface Window {
    google?: {
      accounts: {
        id: {
          initialize(o: { client_id: string; callback: (r: { credential: string }) => void; ux_mode?: string; auto_select?: boolean; nonce?: string }): void;
          renderButton(el: HTMLElement, o: Record<string, unknown>): void;
          disableAutoSelect(): void;
        };
      };
    };
  }
}

function loadGsi(): Promise<void> {
  if (window.google?.accounts) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://accounts.google.com/gsi/client';
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('gsi'));
    document.head.appendChild(s);
  });
}

/**
 * slot に Google のボタンを出す。押して選ばれたら onCredential に IDトークンが届く。
 * 出すたびにサーバーから一度きりの nonce を受け取り（Cookie にも入る）、IDトークンに埋め込ませる。
 * ログインに失敗（invalid_token）したら、もう一度この関数を呼んで nonce を取り直す。
 * 戻り値：'ok' / 'unconfigured'（クライアントID未設定） / 'failed'（スクリプト・nonce を読み込めない）
 */
export async function renderGoogleButton(slot: HTMLElement, onCredential: (credential: string) => void, text: 'signin_with' | 'continue_with' = 'signin_with') {
  const id = import.meta.env.VITE_GOOGLE_CLIENT_ID || (await api.authConfig().catch(() => null))?.googleClientId;
  if (!id) return 'unconfigured' as const;
  let nonce: string;
  try {
    [nonce] = await Promise.all([api.authNonce().then((r) => r.nonce), loadGsi()]);
  } catch {
    return 'failed' as const;
  }
  const g = window.google!.accounts.id;
  g.initialize({ client_id: id, callback: (r) => onCredential(r.credential), ux_mode: 'popup', nonce });
  g.renderButton(slot, { theme: 'filled_black', size: 'large', shape: 'pill', text, locale: 'ja', width: 280 });
  return 'ok' as const;
}
